import Api from '../common/Api';
import {Backend, headers} from "../common/Config";
import Helpers from '../common/Helpers';

export default class Clients {

    static async save(form) {
        const response = await Api.post({
            url: `${Backend}/clients/create`,
            form,
            headers: headers
        });
        return Helpers.dataReturn(response);
    };

    static async update(form) {
        const response = await Api.post({
            url: `${Backend}/clients/update`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async get(page = 0, form) {
        const response = await Api.post({
            url: `${Backend}/clients/list/${page}`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getById(id) {
        const response = await Api.get({
            url: `${Backend}/clients/get/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

}
